import React from 'react';
import { BaseHistoryEntryData, TaskData } from 'nekst-api';
import RecordLayout, { RecordLayoutProps } from './RecordLayout';
import TaskLink from './TaskLink';
import { HistoryEventIconType } from './HistoryEventIcon';

export interface InvitationAcceptedData extends BaseHistoryEntryData{
  participantEmail: string
  participantName: string
  task: TaskData
}

export function EventInvitationRejectedLayout(props: RecordLayoutProps<InvitationAcceptedData>) {
  return (
    <RecordLayout
      text={(
        <>
          <b>{props.record.data.participantName} ({props.record.data.participantEmail})</b>
          {' '}
          declined the invitation to the Appointment Task
          {' '}
          <TaskLink task={props.record.data.task} project={props.record.data.project} />
        </>
      )}
      date={props.record.when}
      iconType={HistoryEventIconType.INVITATION_REJECTED}
    />
  );
}

export default function EventInvitationAcceptedLayout(props: RecordLayoutProps<InvitationAcceptedData>) {
  return (
    <RecordLayout
      text={(
        <>
          <b>{props.record.data.participantName} ({props.record.data.participantEmail})</b>
          {' '}
          accepted the invitation to the Appointment Task
          {' '}
          <TaskLink task={props.record.data.task} project={props.record.data.project} />
        </>
      )}
      date={props.record.when}
      iconType={HistoryEventIconType.INVITATION_ACCEPTED}
    />
  );
}
